import { PageMeta } from "@/components/common/PageMeta";
import { EvidenceBadge } from "@/components/common/EvidenceBadge";
import { EVIDENCE_LABELS, EVIDENCE_DISTINCTIONS } from "@/lib/content";

export default function Evidence() {
  return (
    <>
      <PageMeta title="Evidence framework" description="How DBRF labels the status of resources, projects and heritage claims." />
      <section className="border-b border-[var(--line)] bg-[var(--paper)]">
        <div className="container-dbrf py-16 lg:py-24">
          <p className="eyebrow mb-4">Methodology</p>
          <h1 className="max-w-3xl font-display font-extrabold text-navy" style={{ fontSize: "clamp(2rem,4vw,3.4rem)", lineHeight: 1.04 }}>
            Evidence status, stated plainly.
          </h1>
          <p className="mt-5 max-w-2xl text-lg text-[var(--mineral)]">
            Every substantial resource, project and heritage claim carries a visible or internally
            managed evidence state. The presence of a catalogue entry never implies validation.
          </p>
        </div>
      </section>

      <section className="container-dbrf py-14 lg:py-20">
        <div className="grid gap-5 md:grid-cols-2">
          {EVIDENCE_LABELS.map((e) => (
            <div key={e.label} className="rounded-2xl border border-[var(--line)] bg-[var(--paper)] p-6" data-testid={`evidence-doc-${e.label.toLowerCase().replace(/\s+/g, "-")}`}>
              <EvidenceBadge status={e.label} />
              <p className="mt-4 text-[var(--mineral)]">{e.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="border-t border-[var(--line)] bg-[var(--paper)] py-14 lg:py-20">
        <div className="container-dbrf">
          <p className="eyebrow mb-4">Distinctions we hold</p>
          <h2 className="font-display font-bold text-navy" style={{ fontSize: "clamp(1.6rem,2.6vw,2.4rem)" }}>Do not confuse the left with the right.</h2>
          <div className="mt-8 grid gap-4 md:grid-cols-2" data-testid="evidence-distinctions">
            {EVIDENCE_DISTINCTIONS.map(([a, b]) => (
              <div key={a} className="flex items-center gap-4 rounded-2xl border border-[var(--line)] bg-[var(--ivory)] p-5">
                <span className="flex-1 font-medium text-navy">{a}</span>
                <span className="text-[var(--mineral)]">≠</span>
                <span className="flex-1 text-right font-medium text-[var(--cobalt)]">{b}</span>
              </div>
            ))}
          </div>
          <p className="mt-6 text-sm text-[var(--mineral)]">“Validated” is used only where the record identifies the tested system, baseline, conditions, metric and approving evidence.</p>
        </div>
      </section>
    </>
  );
}
